import React from "react";
import { TableCell, TableRow, Typography } from "@mui/material";
import IconButtonIcons from "../../Common/IconButtonIcons";
import TableCommon from "../../Common/Table";
import { useDispatch } from "react-redux";
import { setSnackBar } from "../../../store/common/commonSlice";
import { format } from "date-fns";
import { DownloadOutlined } from "@mui/icons-material";
import { useDownloadDatabaseBackupMutation } from "../../../store/common/commonApis";

const BackupTableComponent = ({ loading, fetching = false, count, data, pagination, handlePagination }) => {
    const dispatch = useDispatch();
    const [downloadBackup, { isLoading: isDownloading }] = useDownloadDatabaseBackupMutation();

    let columns = [
        {
            title: "Sr. No.",
            sort: false,
            minWidth: 50,
        },
        {
            title: "Backup On",
            field: "createdAt",
            sort: false,
            minWidth: 50,
        },
        {
            title: "Size",
            field: "size",
            sort: true,
            minWidth: 50,
        },
        {
            title: "Type",
            field: "backup_type",
            sort: false,
            minWidth: 80,
        },
        {
            title: "Note",
            field: "backup_note",
            sort: false,
            minWidth: 200,
        },
        {
            title: "Action",
            name: "",
            sort: false,
            minWidth: 200,
        },
    ];

    const downloadBlob = (blob, filename) => {
        if (!blob) {
            throw new Error("Backup file response is empty");
        }
        const fileUrl = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = fileUrl;
        anchor.download = filename || `backup-${Date.now()}.zip`;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.URL.revokeObjectURL(fileUrl);
    };

    const handleDownload = async (row) => {
        try {
            if (row?.url && /^https?:\/\//i.test(row.url)) {
                window.open(row.url, "_blank");
                return;
            }

            if (!row?._id) {
                throw new Error("Backup ID not found");
            }

            const response = await downloadBackup(row._id).unwrap();
            downloadBlob(response?.blob, row?.filename || response?.filename);
        } catch (error) {
            dispatch(
                setSnackBar({
                    open: true,
                    message: error?.data?.message || error?.message || "Unable to download backup",
                    severity: "error",
                }),
            );
        }
    };

    const renderTableData =
        !loading && data && data?.length > 0 ? (
            data.map(function (row, index) {
                return (
                    <TableRow
                        key={index}
                        sx={{ "td, th": { borderBottom: 1, borderBottomColor: "divider", padding: "10px" } }}
                    >
                        <TableCell align="center">{index + 1 + pagination.pageNo * pagination.limit}</TableCell>
                        <TableCell align="center">{format(new Date(row?.createdAt), "dd-MM-yyyy hh:mm:ss")}</TableCell>
                        <TableCell align="center">{row.size}</TableCell>
                        <TableCell align="center">{row?.backup_type || "manual"}</TableCell>
                        <TableCell align="left">
                            <Typography variant="body2" color="text.secondary">
                                {row?.backup_note || "Manual backup from admin panel."}
                            </Typography>
                        </TableCell>
                        <TableCell align="center" component="th" scope="row">
                            <IconButtonIcons
                                title="Download"
                                IconComponent={DownloadOutlined}
                                color="success"
                                disabled={isDownloading}
                                onClick={() => handleDownload(row)}
                            />
                        </TableCell>
                    </TableRow>
                );
            })
        ) : (
            <TableRow sx={{ "td, th": { border: 0, padding: "10px" } }}>
                <TableCell colSpan={6} align="center">
                    Data not found
                </TableCell>
            </TableRow>
        );

    return (
        <TableCommon
            columns={columns}
            tableData={renderTableData}
            count={count}
            loading={loading || fetching}
            pagination={pagination}
            handlePagination={handlePagination}
        />
    );
};

export default BackupTableComponent;
